import { render, staticRenderFns } from "./ModalAddCompany.vue?vue&type=template&id=9369dddc&"
import script from "./ModalAddCompany.vue?vue&type=script&lang=js&"
export * from "./ModalAddCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9369dddc')) {
      api.createRecord('9369dddc', component.options)
    } else {
      api.reload('9369dddc', component.options)
    }
    module.hot.accept("./ModalAddCompany.vue?vue&type=template&id=9369dddc&", function () {
      api.rerender('9369dddc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Customer/ModalAddCompany.vue"
export default component.exports